import React from "react";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { FiUser } from "react-icons/fi"
import { Col, Row } from "reactstrap";
import Card from 'react-bootstrap/Card';
import PasswordReset from "./PasswordReset";
import Notification from "./Notification";
import FactorAuthentication from "./FactorAuth";
const ProfileTabs = () => {
    return (
        <>
            <Row>
                <Col className="header-color" style={{  padding: '20px 20px 100px 20px', }}>
                    <h3 className="text-white" style={{ fontWeight: "500" }}><FiUser/> Profile Settings</h3>
                </Col>
            </Row>
            <Row style={{ marginTop: '-50px' }} >
                <Col lg={12}>
                    <Card >
                        <Card.Body  style={{  padding: '0px' }}>
                            <Tabs defaultActiveKey="password" id="uncontrolled-tab-example" className="subheader-color"  style={{marginTop:'-15px',}}>
                                <Tab eventKey="password" title="Password Reset"><PasswordReset/></Tab>
                                <Tab eventKey="authentication" title="2-Factor Authentication"><FactorAuthentication/></Tab>
                                <Tab eventKey="notification" title="Notification" ><Notification/></Tab>
                            </Tabs>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
          
        </>
    );
}

export default ProfileTabs;